import { render, staticRenderFns } from "./BindTable.vue?vue&type=template&id=3e83001e&scoped=true&"
import script from "./BindTable.vue?vue&type=script&lang=js&"
export * from "./BindTable.vue?vue&type=script&lang=js&"
import style0 from "./BindTable.vue?vue&type=style&index=0&id=3e83001e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e83001e",
  null
  
)

export default component.exports